const Disclaimer = ({ variant, pathIcono, title, subtitle, isVisible }) => {
  return (
    <div className={`disclaimer ${variant} ${isVisible ? "active" : ""}`}>
      <img src={pathIcono} alt="" />
      {window.innerWidth > 768 ? (
        <div>
          <h6>{title}</h6>
          <p>{subtitle}</p>
        </div>
      ) : (
        <>
          <h6>{title}</h6>
          <p>{subtitle}</p>
        </>
      )}
    </div>
  );
};

export default Disclaimer;
